import { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { AppShell } from "@/components/AppShell";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { HeartStraight, CheckCircle } from "@phosphor-icons/react";

export default function Lifesign() {
    const { t } = useApp();
    const [interval, setInterval] = useState(3);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const r = await api.get("/lifesign/status");
                setInterval(r.data.interval_months || 3);
            } catch {}
        })();
    }, []);

    const save = async () => {
        setSaving(true);
        try {
            await api.post("/lifesign/settings", { interval_months: interval });
            toast.success(t("lifesign.saved"));
        } catch (e) { toast.error("Fehler"); }
        finally { setSaving(false); }
    };

    const options = t("lifesign.options");

    return (
        <AppShell>
            <div className="mx-auto max-w-3xl px-6 lg:px-10 py-10 lg:py-14">
                <div>
                    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-shield-terracotta">
                        <HeartStraight size={14} weight="fill" aria-hidden="true" /> Lebenszeichen
                    </div>
                    <h1 className="mt-2 font-heading font-bold text-shield-ink text-3xl sm:text-4xl" data-testid="lifesign-title">
                        {t("lifesign.title")}
                    </h1>
                    <p className="mt-2 text-shield-muted">{t("lifesign.sub")}</p>
                </div>

                <div className="mt-10 grid gap-4">
                    {options.map((opt) => (
                        <label
                            key={opt.m}
                            className={`card-soft p-6 cursor-pointer flex items-center justify-between transition-colors ${interval === opt.m ? "border-shield-forest ring-2 ring-shield-forest/30" : ""}`}
                            data-testid={`lifesign-option-${opt.m}`}
                        >
                            <div className="flex items-center gap-4">
                                <input
                                    type="radio" name="interval" value={opt.m}
                                    checked={interval === opt.m}
                                    onChange={() => setInterval(opt.m)}
                                    className="h-5 w-5 accent-[#2A5A5B]"
                                />
                                <div>
                                    <div className="font-heading font-semibold text-shield-ink text-lg">{opt.label}</div>
                                    <div className="text-sm text-shield-muted">Alle {opt.m} {t("dashboard.months")}</div>
                                </div>
                            </div>
                            {opt.recommended && (
                                <span className="text-xs uppercase tracking-[0.15em] font-semibold text-shield-forest bg-shield-sage/60 h-8 px-3 pill inline-flex items-center gap-1">
                                    <CheckCircle size={12} weight="fill" aria-hidden="true" /> empfohlen
                                </span>
                            )}
                        </label>
                    ))}
                </div>

                <button
                    onClick={save} disabled={saving}
                    className="mt-10 inline-flex items-center gap-2 h-14 px-8 pill bg-shield-forest text-white text-lg font-semibold hover:bg-shield-forestDeep transition-colors disabled:opacity-70"
                    data-testid="lifesign-save-btn"
                >
                    {saving ? t("common.loading") : t("lifesign.save")}
                </button>
            </div>
        </AppShell>
    );
}
